import React, { useEffect, useState } from "react";
import { AppState, getLanguageByDefault } from "../../services/app.service";
import Loader from "../Loader";
import NoData from "../../pages/main/NoData";
import { Accordion, Card, Col, Nav } from "react-bootstrap";
import {
  ClassResponse,
  ContentResponse,
  CourseResponse,
} from "../../services/api.response.service";
import Api from "../../services/api.service";
import { toInteger } from "lodash";
import { Mixpanel } from "../../services/mixpanel";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import CoursesSection from "./CoursesSection";
import { Doughnut } from "react-chartjs-2";
// import { Chart, ArcElement } from 'chart.js';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Link } from "react-router-dom";
import { RouteEndpoints } from "../../services/route.service";
import ContentProviderCardSmall from "../ContentProviderCardSmall";
import ClassCardSmall from "../ClassCardSmall";
import { ReactComponent as InfoIconInactive } from "../../assets/svg/info-icon-inactive.svg";
import { ReactComponent as InfoIconActive } from "../../assets/svg/info-icon-active.svg";
interface props {
  contentId: number;
  classId: number | undefined;
  handleSetCourse: (id: string, title: string) => void;
}

const ClassOutline = ({ handleSetCourse, contentId, classId }: props) => {
  // Chart.register(ArcElement);
  ChartJS.register(ArcElement, Tooltip, Legend);
  const getLanguage = getLanguageByDefault();
  const [contents, setContents] = useState<ContentResponse[] | []>([]);
  const [classDetails, setClass] = useState<ClassResponse>();

  useEffect(() => {
    if (classId && classId > 0) {
      getContents(classId);
      getClass(classId);
    }
  }, [classId]);

  //
  // const getContents = async (classId: string|number) => {
  //     // const contentsObj = await Api.getPublicClassCourse((toInteger(classId)));
  //     const contentsObj = await Api.getClassCourseStructure((toInteger(classId)));
  //     if (contentsObj) {
  //         // console.log("contents",contentsObj.data);
  //         setContents(contentsObj.data.data);
  //         setClass(contentsObj.data.content_class);
  //         return contentsObj.data;
  //     }
  //     return null;
  // };

  const getClass = async (classId: string | number) => {
    const classObj = await Api.getActiveClassByMeans(String(classId));
    if (classObj) {
      // console.log("the class", classObj.data.data);
      setClass(classObj.data.data);
      return classObj.data.data;
    }
    return null;
  };

  //
  const getContents = async (classId: string | number) => {
    // const contentsObj = await Api.getPublicClassCourse((toInteger(classId)));
    const contentsObj = await Api.getClassCourses(toInteger(classId));
    if (contentsObj) {
      // console.log("contents",contentsObj.data);
      setContents(contentsObj.data.data);
      // setClass(contentsObj.data.content_class);
      return contentsObj.data.data;
    }
    return null;
  };

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;
  function setTheCourse(id: string, title: string) {
    handleSetCourse(id, title);

    // Mixpanel.track('Tap Course Outline item', {
    //     'with': currentUser?.id ? "Auth" : "Guest",
    //     'user_id': currentUser?.id,
    //     'course_id': id,
    //     'course_name': title,
    // });
    setAddRead(addRead + 1);
  }

  const [addRead, setAddRead] = useState<number>(0);
  function getTotalAccesses() {
    return (classDetails?.contents_accessed || 0) + addRead;
  }

  function getTotalTopics() {
    return classDetails?.total_topics || classDetails?.total_courses || 0;
  }

  return (
    <>
      <Card className="course-outline">
        <div className="course-outline-scroll scrollbar-dd">
          {classDetails && (
            <div>
              <Col
                md={12}
                className="d-flex align-items-center justify-content-between mb-3 mt-3"
              >
                <h5 className="header-fw mb-0" style={{ fontWeight: 500 }}>
                  {getLanguage.yourProgress} :
                </h5>
              </Col>

              {contents.length > 0 &&
              classDetails &&
              getTotalAccesses() > 0 &&
              getTotalTopics() > 0 ? (
                <Card
                  className={"course-card"}
                  style={{ marginLeft: "5px !important" }}
                >
                  <Card.Body className="progress-card-body">
                    <div className="progress-card-inner d-flex align-items-center flex-wrap gap-3 justify-content-center">
                      <div className="progress-card-chart flex-shrink-0">
                        <DoughnutChart
                          percentage={Math.round(
                            (getTotalAccesses() / getTotalTopics()) * 100,
                          )}
                        />
                      </div>
                      <div className="progress-card-text flex-grow-1 min-w-0 text-center">
                        <h5 className="header-fw mb-0">
                          {`${getTotalAccesses()} ${getLanguage.of} ${getTotalTopics()} ${getLanguage.completed}`}
                        </h5>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ) : (
                ""
              )}
            </div>
          )}
          <div
            className="progress-info-content"
            style={{ marginBottom: "22px" }}
          >
            {getLanguage.progressPointsPrizesInfo}
          </div>

          <hr
            className="ec-hr"
            style={{
              margin: "0 0 1rem 0",
              borderTop: "3px solid #e9ecef",
            }}
          />
          {/*<hr className="ec-hr-gray"/>*/}

          <Card.Header
            className="text-dark border-0"
            style={{ padding: "0px" }}
          >
            {classDetails && (
              <>
                <ClassCardSmall data={classDetails!} />
                {/*<ContentProviderCardSmall data={classDetails?.content_provider!} />*/}
              </>
            )}
          </Card.Header>
          <Card.Body className="p-0">
            {contents.length > 0 && classDetails ? (
              <CoursesSection
                classDetails={classDetails}
                contentId={contentId}
                isShortForm={true}
                handleSetCourse={(id: string) => {
                  setTheCourse(
                    id,
                    contents.find((c) => c.id === toInteger(id))?.title || "",
                  );
                }}
              />
            ) : (
              <Loader noCard imageLoader />
            )}
          </Card.Body>
        </div>
      </Card>
    </>
  );
};

class DoughnutChart extends React.Component<{ percentage: any }> {
  render() {
    let { percentage } = this.props;
    const data = {
      labels: ["Completed", "Remaining"],
      datasets: [
        {
          data: [percentage, 100 - percentage],
          backgroundColor: ["#EA983F", "#e0e0e0"], // Green for completed, light gray for remaining rgb(234, 152, 63)
          borderWidth: 0,
        },
      ],
    };

    const centerTextPlugin = {
      id: "centerText",
      beforeDraw: (chart: ChartJS<"doughnut", number[], unknown>) => {
        const { width } = chart;
        const { height } = chart;
        const ctx = chart.ctx;
        ctx.restore();

        const fontSize = ((height * 1.5) / 100).toFixed(2);
        ctx.font = `${fontSize}em sans-serif`;
        ctx.textBaseline = "middle";

        const text = `${percentage}%`;
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;

        ctx.fillStyle = "#333";
        ctx.fillText(text, textX, textY);
        ctx.save();
      },
    };

    const options = {
      cutout: "70%",
      plugins: {
        legend: { display: false },
      },
    };

    return (
      <div style={{ width: 70, height: 70 }}>
        <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
      </div>
    );
  }
}

export default ClassOutline;
